import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddPackageInsuranceMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  packageInsuranceInput: GraphQLTypes.CreateInsurancePackageInput;
}>;


export type AddPackageInsuranceMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'addPackageInsurance'>
);


export const AddPackageInsuranceDocument = /*#__PURE__*/ gql`
    mutation addPackageInsurance($packageId: String!, $packageInsuranceInput: CreateInsurancePackageInput!) {
  addPackageInsurance(
    packageId: $packageId
    packageInsuranceInput: $packageInsuranceInput
  )
}
    `;

/**
 * __useAddPackageInsuranceMutation__
 *
 * To run a mutation, you first call `useAddPackageInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPackageInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPackageInsuranceMutation, { data, loading, error }] = useAddPackageInsuranceMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      packageInsuranceInput: // value for 'packageInsuranceInput'
 *   },
 * });
 */
export function useAddPackageInsuranceMutation(baseOptions?: Apollo.MutationHookOptions<AddPackageInsuranceMutationResult, AddPackageInsuranceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPackageInsuranceMutationResult, AddPackageInsuranceMutationVariables>(AddPackageInsuranceDocument, options);
      }
export type AddPackageInsuranceMutationHookResult = ReturnType<typeof useAddPackageInsuranceMutation>;